import config from '../config';


const findIfExempt = (userid: string) => {
    const walkMeExemptUsers = config.dapWalkMeExemptUsers.split(';');
    const dapWalkeMeEnabled = config.dapWalkeMeEnabled === 'true';
    return dapWalkeMeEnabled && !walkMeExemptUsers.includes(userid);

}

export { findIfExempt };